import Snackbar from 'components/Snackbar';
import { SnackbarKey, useSnackbar } from 'notistack';

import { OptionProps } from './types';

export default function useNotification() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const pushNotification = (message: string, options?: OptionProps) => {
    const { variant } = options || { variant: undefined };

    return enqueueSnackbar(message, {
      autoHideDuration: 5000,
      preventDuplicate: true,
      content: (key) => {
        return (
          <Snackbar
            id={`${key}`}
            message={message}
            variant={variant || 'info'}
            onClick={options?.onClick}
          />
        );
      },
      ...options
    });
  };

  const dismissAllNotifications = () => closeSnackbar();
  const dismissNotification = (id: SnackbarKey) => closeSnackbar(id);

  return {
    pushNotification,
    dismissAllNotifications,
    dismissNotification
  };
}
